import React, { useEffect, useState } from "react";
import { ReactComponent as MoreIcon } from "assets/icons/more.svg";
import { useOrganiseList } from "context/OrganiseListContext";
import moment from "moment";
import "moment/locale/it";
import { useInView } from "react-intersection-observer";

const OrganizerLog = () => {
  const {
    organiseLogs,
    fetchOrganiseLog,
    selectedOrganiseList,
    isFetchingList,
    isFetchingOrganiseLogs,
  } = useOrganiseList();
  const [selectedModifiedDate, setSelectedModifiedDate] = useState("");
  moment.locale("it");

  useEffect(() => {
    // Load organiser logs
    if (!isFetchingList && selectedOrganiseList) {
      fetchOrganiseLog();
    }
  }, [isFetchingList, selectedOrganiseList]);

  // Bookmark pagination
  const { ref: lastElementRef, inView } = useInView({
    threshold: 1.0,
    triggerOnce: false,
    rootMargin: "0px 0px 10px 0px",
  });

  // Pagination apply
  useEffect(() => {
    if (
      inView &&
      organiseLogs &&
      organiseLogs?.pagination?.nextPage &&
      !isFetchingOrganiseLogs
    ) {
      fetchOrganiseLog(organiseLogs?.pagination?.nextPage);
    }
  }, [inView, isFetchingOrganiseLogs, organiseLogs?.pagination]);

  return (
    <div className="border border-[#EEEEEE] col-span-2 rounded-[10px] px-[20.27px] pt-[10px] h-[155px]">
      <div className="flex items-center justify-between ">
        <h1 className="text-[12px] font-semibold leading-[24px] text-black">
          Lista modificata il
        </h1>
        {/* <MoreIcon className="cursor-pointer" /> */}
      </div>
      <div className="grid gap-y-3 max-h-[110px] overflow-y-auto scroll-container-organize">
        {organiseLogs &&
          organiseLogs?.results?.length > 0 &&
          organiseLogs?.results?.map(({ _id, createdAt }, index) => (
            <label
              ref={
                index === organiseLogs?.results?.length - 1
                  ? lastElementRef
                  : null
              }
              key={_id}
              htmlFor={_id}
              className={`w-full cursor-pointer flex items-center space-x-2 text-[14px] font-medium text-[#535353]`}
            >
              <input
                className="hero-radio-input !w-[17px] !h-[17px] !mr-2 checked:!border-[5px]"
                type="radio"
                id={_id}
                checked={selectedModifiedDate === _id}
                onChange={(e) => setSelectedModifiedDate(_id)}
                disabled
              />
              {moment(createdAt).format("DD MMMM YYYY")}
              {/* <img
              src={avatar}
              className="w-[24px] h-[24px] rounded-full object-cover"
            /> */}
            </label>
          ))}
      </div>
    </div>
  );
};

export default OrganizerLog;
